import { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import SEO from '../components/SEO'
import './NotFound.css'

function NotFound() {
  const navigate = useNavigate()
  const [progress, setProgress] = useState(0)

  useEffect(() => {
    // Set body background to black for 404 page
    document.body.style.backgroundColor = '#0a0a0a'
    
    const duration = 5000 // 5 seconds
    const interval = 50 // Update every 50ms
    const steps = duration / interval
    let currentStep = 0

    const timer = setInterval(() => {
      currentStep++
      setProgress((currentStep / steps) * 100)
      
      if (currentStep >= steps) {
        clearInterval(timer)
        navigate('/')
      }
    }, interval)

    return () => {
      clearInterval(timer)
      document.body.style.backgroundColor = ''
    }
  }, [navigate])

  return (
    <>
      <SEO 
        title="Page Not Found" 
        description="The page you're looking for doesn't exist."
      />
      
      <section className="not-found">
        <div className="not-found-content">
          <h1>404</h1>
          <h2>Page not found</h2>
          <p>The page you're looking for doesn't exist or has been moved.</p>
          <p className="redirect-text">You'll be redirected to the homepage shortly.</p>
          
          <div className="progress-bar-container">
            <div className="progress-bar" style={{ width: `${progress}%` }} />
          </div>
          
          <Link to="/" className="back-home">Return to homepage</Link>
        </div>
      </section>
    </>
  )
}

export default NotFound
